module.exports = __webpack_public_path__ + "img/视频服务-bj.cb109696.png";